var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Modal from 'react-bootstrap/lib/Modal';
import Button from '@/shared/components/Button';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import ToastrService from '@/shared/services/ToastrService';
import adminpulse from '@/shared/utils/adminpulse';
var messages = defineMessages({
    EmailEditor: {
        id: 'EmailEditor',
        defaultMessage: 'E-mail editor',
    },
    SendTo: {
        id: 'SendTo',
        defaultMessage: 'Send to',
    },
    CC: {
        id: 'CC',
        defaultMessage: 'CC',
    },
    BCC: {
        id: 'BCC',
        defaultMessage: 'BCC',
    },
    Subject: {
        id: 'Subject',
        defaultMessage: 'Subject',
    },
    Content: {
        id: 'Content',
        defaultMessage: 'Content',
    },
    Cancel: {
        id: 'Cancel',
        defaultMessage: 'Cancel',
    },
    Send: {
        id: 'Send',
        defaultMessage: 'Send',
    },
    EmailSent: {
        id: 'EmailSent',
        defaultMessage: 'EmailSent',
    },
    SelectOrTypeEmail: {
        id: 'SelectOrTypeEmail',
        defaultMessage: 'Select or type an e-mail address',
    },
    AddEmailAddress: {
        id: 'AddEmailAddress',
        defaultMessage: 'Add e-mail address',
    },
    RemoveEmailAddress: {
        id: 'RemoveEmailAddress',
        defaultMessage: 'Remove e-mail address',
    },
    msgInvalidEmailAddress: {
        id: 'msgInvalidEmailAddress',
        defaultMessage: 'An invalid email address was entered.',
    },
});
var EmailAddressList = function (_a) {
    var addresses = _a.addresses, onChange = _a.onChange, onAdd = _a.onAdd, placeholder = _a.placeholder, addTitle = _a.addTitle, removeTitle = _a.removeTitle, _b = _a.required, required = _b === void 0 ? false : _b, _c = _a.minEntries, minEntries = _c === void 0 ? 0 : _c;
    return (_jsxs("div", { children: [addresses.map(function (email, index) { return (_jsxs("div", __assign({ className: "row margin10B" }, { children: [_jsx("div", __assign({ className: "col-sm-6" }, { children: _jsx("input", { type: "email", className: "form-control".concat(required && !adminpulse.isValidEmail(email) ? ' markedError' : ''), value: email, onChange: function (e) {
                                var updated = __spreadArray([], addresses, true);
                                updated[index] = e.target.value;
                                onChange(updated);
                            }, placeholder: placeholder }) })), _jsx("div", __assign({ className: "col-sm-1" }, { children: addresses.length > minEntries && (_jsx("a", __assign({ className: "clickable", title: removeTitle, onClick: function () { return onChange(addresses.filter(function (_, i) { return i !== index; })); } }, { children: _jsx("i", { className: "fa fa-remove" }) }))) }))] }), index)); }), _jsx("div", { children: _jsx("a", __assign({ className: "btn btn-default btn-xs", title: addTitle, onClick: onAdd }, { children: _jsx("i", { className: "fa fa-plus" }) })) })] }));
};
var MailEmailDomainCnameInfoModal = function (_a) {
    var show = _a.show, onClose = _a.onClose, companyId = _a.companyId;
    var intl = useIntl();
    var _b = useState(null), preview = _b[0], setPreview = _b[1];
    var _c = useState(null), previewError = _c[0], setPreviewError = _c[1];
    var _d = useState(['']), sendTo = _d[0], setSendTo = _d[1];
    var _e = useState([]), cc = _e[0], setCc = _e[1];
    var _f = useState([]), bcc = _f[0], setBcc = _f[1];
    var _g = useState(false), sending = _g[0], setSending = _g[1];
    useEffect(function () {
        if (!show)
            return;
        setPreview(null);
        setPreviewError(null);
        api.base
            .get("/api/settings/GetEmailDomainInfoMail?id=".concat(companyId))
            .then(function (_a) {
            var _b;
            var data = _a.data;
            if (data) {
                setPreview(data);
                if (((_b = data.cc) === null || _b === void 0 ? void 0 : _b.length) && cc.length === 0) {
                    setCc(data.cc);
                }
                if (sendTo.length === 0 || (sendTo.length === 1 && !sendTo[0])) {
                    setSendTo(['']);
                }
            }
        })
            .catch(function (error) {
            setPreviewError('Error loading email preview');
            handleHttpError(intl)(error);
        });
    }, [show, companyId]);
    var validateEmails = function (emails) {
        for (var _i = 0, emails_1 = emails; _i < emails_1.length; _i++) {
            var email = emails_1[_i];
            if (!adminpulse.isValidEmail(email)) {
                ToastrService.error(intl.formatMessage(messages.msgInvalidEmailAddress));
                return false;
            }
        }
        return true;
    };
    var handleSend = function () { return __awaiter(void 0, void 0, void 0, function () {
        var filteredTo, filteredCc, filteredBcc, payload, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!preview || !preview.subject || !preview.body || sending)
                        return [2 /*return*/];
                    filteredTo = sendTo.filter(function (e) { return e.trim(); });
                    filteredCc = cc.filter(function (e) { return e.trim(); });
                    filteredBcc = bcc.filter(function (e) { return e.trim(); });
                    if (filteredTo.length === 0)
                        return [2 /*return*/];
                    if (!validateEmails(filteredTo))
                        return [2 /*return*/];
                    if (!validateEmails(filteredCc))
                        return [2 /*return*/];
                    if (!validateEmails(filteredBcc))
                        return [2 /*return*/];
                    setSending(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    payload = __assign(__assign({}, preview), { to: filteredTo, cc: filteredCc, bcc: filteredBcc, recipients: filteredTo });
                    return [4 /*yield*/, api.base.post('/api/settings/SendEmailDomainInfoMail', payload)];
                case 2:
                    _a.sent();
                    ToastrService.success(intl.formatMessage(messages.EmailSent));
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    handleHttpError(intl)(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setSending(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var placeholder = intl.formatMessage(messages.SelectOrTypeEmail);
    var addTitle = intl.formatMessage(messages.AddEmailAddress);
    var removeTitle = intl.formatMessage(messages.RemoveEmailAddress);
    return (_jsxs(Modal, __assign({ show: show, onHide: onClose, dialogClassName: "modal-xl", enforceFocus: false, backdrop: "static" }, { children: [_jsx(Modal.Header, __assign({ closeButton: true }, { children: _jsx(Modal.Title, { children: intl.formatMessage(messages.EmailEditor) }) })), _jsx(Modal.Body, { children: _jsxs("div", __assign({ className: "form-horizontal", role: "form" }, { children: [_jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("div", __assign({ className: "col-sm-2 control-label" }, { children: intl.formatMessage(messages.SendTo) })), _jsx("div", __assign({ className: "col-sm-7" }, { children: _jsx(EmailAddressList, { addresses: sendTo, onChange: setSendTo, onAdd: function () { return setSendTo(__spreadArray(__spreadArray([], sendTo, true), [''], false)); }, placeholder: placeholder, addTitle: addTitle, removeTitle: removeTitle, required: true, minEntries: 1 }) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("div", __assign({ className: "col-sm-2 control-label" }, { children: intl.formatMessage(messages.CC) })), _jsx("div", __assign({ className: "col-sm-7" }, { children: _jsx(EmailAddressList, { addresses: cc, onChange: setCc, onAdd: function () { return setCc(__spreadArray(__spreadArray([], cc, true), [''], false)); }, placeholder: placeholder, addTitle: addTitle, removeTitle: removeTitle }) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("div", __assign({ className: "col-sm-2 control-label" }, { children: intl.formatMessage(messages.BCC) })), _jsx("div", __assign({ className: "col-sm-7" }, { children: _jsx(EmailAddressList, { addresses: bcc, onChange: setBcc, onAdd: function () { return setBcc(__spreadArray(__spreadArray([], bcc, true), [''], false)); }, placeholder: placeholder, addTitle: addTitle, removeTitle: removeTitle }) }))] })), preview && (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("div", __assign({ className: "col-sm-2 control-label" }, { children: intl.formatMessage(messages.Subject) })), _jsx("div", __assign({ className: "col-sm-10" }, { children: _jsx("input", { type: "text", className: "form-control", maxLength: 500, value: preview.subject || '', onChange: function (e) { return setPreview(__assign(__assign({}, preview), { subject: e.target.value })); }, required: true }) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("div", __assign({ className: "col-sm-2 control-label" }, { children: intl.formatMessage(messages.Content) })), _jsx("div", __assign({ className: "col-sm-10" }, { children: _jsx("div", { className: "form-control", style: { height: 'auto', minHeight: 200 }, contentEditable: true, dangerouslySetInnerHTML: { __html: preview.body || '' }, onBlur: function (e) { return setPreview(__assign(__assign({}, preview), { body: e.currentTarget.innerHTML })); } }) }))] }))] })), previewError && (_jsx("div", __assign({ className: "form-group" }, { children: _jsx("div", __assign({ className: "errorMsg col-sm-offset-2 col-sm-10" }, { children: previewError })) })))] })) }), _jsxs(Modal.Footer, { children: [_jsx(Button, __assign({ onClick: onClose, disabled: sending, name: "MailCnameInfo-Cancel" }, { children: intl.formatMessage(messages.Cancel) })), _jsx(Button, __assign({ onClick: handleSend, disabled: sending || !(preview === null || preview === void 0 ? void 0 : preview.subject) || !(preview === null || preview === void 0 ? void 0 : preview.body), btnClassName: "btn-inverse", name: "MailCnameInfo-Send" }, { children: intl.formatMessage(messages.Send) }))] })] })));
};
export default MailEmailDomainCnameInfoModal;
